import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastService } from 'projects/speaker-platform/src/app/services/toast.service';
import { LoaderComponent } from '@common/components/loader/loader.component';
import {ChoixCod, ZappTablette} from '../../../types/tablettes';

@Component({
  selector: 'app-speaker-edit-parameters',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent
],
  templateUrl: './speaker-edit-parameters.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./speaker-edit-parameters.component.scss']
})
export class SpeakerEditParametersComponent implements OnInit, OnChanges {
  constructor(private fb: FormBuilder, private toastService: ToastService) {}

  @Output() saveParametersEvent = new EventEmitter();
  @Output() disableSpeakerEvent = new EventEmitter();
  @Output() onDeleteModeFactu = new EventEmitter();
  @Output() onAddNewModeFactu = new EventEmitter();
  @Output() isPristine = new EventEmitter<boolean>();

  @Input() joursenregistrement: string = '';
  @Input() nbtxtpv: number = 0;
  @Input() nbpvjour: number = 0;
  @Input() onair: boolean = false;
  @Input() nbonairjour: number = 0;
  @Input() modesFacturation: any = [];
  @Input() traductrice: boolean = false;
  @Input() domaine: string = '';
  @Input() isLoading: boolean = false;
  @Input() zcg: ChoixCod[] = [];
  @Input() modeFactuZapp: ZappTablette[] = [];
  @Input() nbTextesMaxJour: number = 0;
  @Input() prix: string = '0';


  recordDays: string[] = [];
  domain: string[] = [];

  editParameters = this.fb.group({
    __joursenregistrementMon: [false],
    __joursenregistrementTue: [false],
    __joursenregistrementWed: [false],
    __joursenregistrementThu: [false],
    __joursenregistrementFri: [false],
    __joursenregistrementSat: [false],
    __joursenregistrementSun: [false],
    disponibilite: [this.joursenregistrement],
    nbtxtpv: new FormControl(this.nbtxtpv, Validators.required),
    nbpvjour: new FormControl(this.nbpvjour, Validators.required),
    modesFacturation: [''],
    onair: [this.onair],
    nbonairjour: [this.nbonairjour],
    traductrice : [this.traductrice],
    nbTextesMaxJour: [0],
    prix: ['']
  });

  showRowAddModeFactu: boolean = false;
  selectedTypeProd: string = '0';
  selectedTypeFactu: number = 0;

  ngOnInit(): void {
    this.recordDays =
      this.joursenregistrement.length > 0
        ? this.joursenregistrement.split(',')
        : [];
    this.domain = this.domaine?.length > 0 ? this.domaine.split(',') : [];
    this.updatePristineStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.recordDays = this.joursenregistrement.split(',');
    this.editParameters.patchValue({
      __joursenregistrementMon: this.joursenregistrement.includes('Mon'),
      __joursenregistrementTue: this.joursenregistrement.includes('Tue'),
      __joursenregistrementWed: this.joursenregistrement.includes('Wed'),
      __joursenregistrementThu: this.joursenregistrement.includes('Thu'),
      __joursenregistrementFri: this.joursenregistrement.includes('Fri'),
      __joursenregistrementSat: this.joursenregistrement.includes('Sat'),
      __joursenregistrementSun: this.joursenregistrement.includes('Sun'),
      disponibilite: this.joursenregistrement,
      nbtxtpv: this.nbtxtpv,
      nbpvjour: this.nbpvjour,
      modesFacturation: this.modesFacturation,
      onair: this.onair,
      nbonairjour: this.nbonairjour,
      traductrice: this.traductrice,
      nbTextesMaxJour: this.nbTextesMaxJour,
      prix: this.prix,
    });
  }


  saveMultiCheck(event: any, dataArray: string[], input: string) {
    if (event.target.checked) {
      dataArray.push(event.target.value);
    } else {
      const index = dataArray.indexOf(event.target.value);
      if (index > -1) {
        dataArray.splice(index, 1);
      }
    }

    this.editParameters.patchValue({ [input]: dataArray.toString() });
  }

  saveParameters() {
    const body = Object.fromEntries(
      Object.entries(this.editParameters.value).filter(
        ([k]) => !k.includes('__')
      )
    );

    const formData = new FormData();

    for (let [k, v] of Object.entries(body)) {
      if (v !== null) {
        //@ts-expect-error
        formData.append(k, v);
      }
    }

    if (this.editParameters.valid) {
      this.saveParametersEvent.emit(formData);
      return;
    }
    this.toastService.show('Le formulaire est invalide', 'danger');
  }

  resetForm() {
    this.editParameters.reset({
      __joursenregistrementMon: this.joursenregistrement.includes('Mon'),
      __joursenregistrementTue: this.joursenregistrement.includes('Tue'),
      __joursenregistrementWed: this.joursenregistrement.includes('Wed'),
      __joursenregistrementThu: this.joursenregistrement.includes('Thu'),
      __joursenregistrementFri: this.joursenregistrement.includes('Fri'),
      __joursenregistrementSat: this.joursenregistrement.includes('Sat'),
      __joursenregistrementSun: this.joursenregistrement.includes('Sun'),
      disponibilite: this.joursenregistrement,
      nbtxtpv: this.nbtxtpv,
      nbpvjour: this.nbpvjour,
      onair: this.onair,
      modesFacturation: this.modesFacturation,
      nbonairjour: this.nbonairjour,
      traductrice: this.traductrice,
      nbTextesMaxJour: this.nbTextesMaxJour,
      prix: this.prix,
    });

    this.updatePristineStatus();
  }

  updatePristineStatus() {
    this.isPristine.emit(this.editParameters.pristine);
  }

  disableSpeaker() {
    this.disableSpeakerEvent.emit();
  }

  displayActualMode(mode: any) {
    return this.zcg.find(elmnt => elmnt.cc_code === mode.categorie_seance)?.cc_libelle
  }

  deleteModeFactu(id : number)  {
    this.onDeleteModeFactu.emit(id)
  }

  addNewModeFactu()  {
    const body = {
      "idModeFacturation": Number(this.selectedTypeFactu),
      "codeCategorie": this.selectedTypeProd
    }
    this.onAddNewModeFactu.emit(body)
    this.showRowAddModeFactu = false;
    this.selectedTypeProd = '';
    this.selectedTypeFactu = 0;
  }

  get methodFacturationForTelephone(): string {
      return this.modesFacturation.find((elmnt: any) => elmnt.categorie_seance === '001')?.mode_facturation?.filler ?? 'seance';
  }
}
